import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { isUserLogin } from '@eureka/utils/account';

export interface PatentInfo {
    pn: string
    title: string
    current_assignee: {
        lang: 'CN' | 'EN'
        ans_id: string
        name: string
        organization?: {
            display_name_cn?: string
            display_name_en: string
            entity_id: string
        }
    }[]
    patent_id: string
    simple_legal_status: string
    abst: string
    country: string
}

export interface PnApi {
    getPatentInfo(data: {pns: string[]}): Promise<Record<string, PatentInfo>>;
}

export const PnApi = Symbol('PnApi');

@injectable()
export class PnApiImpl extends PsHttpService implements PnApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    async getPatentInfo(data: {pns: string[]}) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/guest'
        return this.post<PatSnapCommonResponseData<Record<string, PatentInfo>>>({
            url: `${base}/patent/batch_card`,
            data,
        }).then((res) => {
            return res as unknown as Record<string, PatentInfo>;
        });
    }
}
